var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card session-card",
      class: { selectedSession: _vm.examSession == _vm.selectedSession },
      on: {
        click: function($event) {
          return _vm.setSelectedSession(_vm.examSession)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("p", { staticClass: "card-title" }, [
            _c("span", { staticClass: "text-uppercase font-weight-bold" }, [
              _vm._v(_vm._s(_vm.examSession.examCenter.city))
            ]),
            _vm._v(" - CRR " + _vm._s(_vm.examSession.type))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "card-subtitle mb-2" }, [
            _vm._v(
              "Le " +
                _vm._s(
                  _vm._f("moment")(
                    _vm.examSession.startDate,
                    "DD/MM/YYYY à HH:mm"
                  )
                )
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-4" }, [
            _c("div", { staticClass: "col-12 col-xl-6" }, [
              _c("p", { staticClass: "txt-green" }, [
                _c("strong", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.remainingPlaces) +
                      " place" +
                      _vm._s(_vm.remainingPlaces > 1 ? "s" : "") +
                      " restante" +
                      _vm._s(_vm.remainingPlaces > 1 ? "s" : "") +
                      " sur " +
                      _vm._s(_vm.examSession.nbPlaceMax) +
                      "\n                "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-xl-6" }, [
              _c("div", { staticClass: "float-right" }, [
                _vm.hasDetails
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "details-" + _vm.examSession.id,
                            expression: "'details-' + examSession.id"
                          }
                        ],
                        staticClass: "card-link mr-4 link-underline"
                      },
                      [_vm._v("Détails")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.setSessionToRegister(_vm.examSession)
                      }
                    }
                  },
                  [_vm._v("S'inscrire")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("b-collapse", { attrs: { id: "details-" + _vm.examSession.id } }, [
            _c("p", { staticClass: "card-text my-2" }, [
              _vm._v(_vm._s(_vm.examSession.examCenter.infosComplement))
            ]),
            _vm._v(" "),
            _vm.hasAccessUrl
              ? _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "link-underline",
                      attrs: {
                        href: _vm.examSession.examCenter.accessUrl,
                        target: "_blank"
                      }
                    },
                    [_vm._v("Plan d'accès")]
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }